<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="page-header meetings-page__header">
  <h2>Meetings</h2>
  @if (ehInterno()) {
    <div class="meetings-page__header-actions">
      <!-- Card 3803: as regras de quem vê cada call. -->
      <app-button
        [label]="'Como funciona a visibilidade'"
        [icon]="'pi pi-info-circle'"
        [theme]="'link'"
        [type]="'button'"
        (sendButtonClick)="rulesOpen.set(true)" />
      <app-button
        [label]="'Adicionar bot na call'"
        [icon]="'pi pi-video'"
        [type]="'button'"
        (sendButtonClick)="modalEnviarBot?.open()" />
    </div>
  }
</header>

@if (papelResolvido() && !ehInterno()) {
  <!--
    Chegou aqui por URL direta sem ser do time interno: o `PermissionGuard` só olha a permissão, e
    o backend recusa quem tem parceiro. A tela explica em vez de mostrar uma lista que sempre
    falharia.
  -->
  <div class="meetings-page__nota" role="note">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <div>
      <strong>Esta tela é do time interno da Legatus.</strong>
      <p>
        As reuniões de um deal ficam na aba <em>Reuniões</em> da tela do deal, em
        <a routerLink="/dashboard/commercial/my-deals">Comercial › Deals</a>.
      </p>
    </div>
  </div>
} @else if (ehInterno()) {
  <app-meetings-kpis
    [totalProximas]="totalProximas()"
    [proxima]="proxima()"
    [totalBots]="totalBots()"
    [totalSemDeal]="totalSemDeal()"
    (escolher)="escolherIndicador($event)" />

  <div class="meetings-page__toolbar">
    <div class="meetings-page__tabs" role="tablist" aria-label="Recorte das meetings">
      @for (item of abasDaTela; track item) {
        <button
          type="button"
          role="tab"
          class="meetings-page__tab"
          [class.meetings-page__tab--active]="aba() === item"
          [attr.aria-selected]="aba() === item"
          (click)="trocarAba(item)">
          {{ rotulos[item] }}
          @if (item === 'proximas' && totalProximas()) {
            <span class="meetings-page__tab-count">{{ totalProximas() }}</span>
          }
        </button>
      }
    </div>

    <div class="meetings-page__search">
      <app-search
        [value]="busca()"
        [realTime]="true"
        [placeholder]="'Buscar por título ou participante'"
        (sendSearch)="handleSearch($event)" />
      <!-- Filtros nas três abas (card 3221): somam ao recorte da aba e seguem ao trocar de aba. -->
      <button
        type="button"
        class="meetings-page__filter-btn"
        [class.meetings-page__filter-btn--active]="filtrosAtivos().length > 0"
        title="Filtros"
        aria-label="Abrir os filtros"
        (click)="filtroAberto.set(true)">
        <i class="pi pi-sliders-h" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <p class="meetings-page__hint">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    @switch (aba()) {
      @case ('recentes') {
        Suas reuniões que já começaram, da mais recente para a mais antiga. O vínculo com o deal da
        empresa participante é automático; use o menu da linha para ajustar.
      }
      @case ('proximas') {
        Suas próximas reuniões, da mais perto de agora para a mais distante. Desligue o bot da
        reunião que não deve ser gravada.
      }
      @case ('arquivadas') {
        Reuniões arquivadas: não aparecem nas outras abas nem no card de reuniões da Home. Use
        Restaurar no menu da linha para trazer uma de volta.
      }
      @default {
        As reuniões de que você participou, as que tiveram alguém de fora da Legatus e as que alguém
        compartilhou ou liberou para o time.
      }
    }
  </p>

  <!-- Card 3803: filtro rápido "Para o cliente", com a contagem do backend. -->
  <app-meetings-client-visibility-chips
    class="meetings-page__client-chips"
    [selected]="selectedClientVisibility()"
    [counts]="visibilityCounts()"
    (selectedChange)="chooseClientVisibility($event)" />

  <app-meetings-filter
    [isVisible]="filtroAberto()"
    [currentFilters]="filtros()"
    (sendCloseFilter)="filtroAberto.set(false)"
    (sendFilter)="handleFilter($event)"
    (sendActiveFilters)="onActiveFiltersChanged($event)" />

  <app-active-filters
    [filterConfigs]="filtrosAtivos()"
    [showClearButton]="true"
    [clearButtonLabel]="'Limpar filtros'"
    (filterRemoved)="onFilterRemoved($event)"
    (allFiltersCleared)="onAllFiltersCleared()" />

  @if (aba() === 'proximas' && soComBot()) {
    <div class="meetings-page__quick-filter">
      <span>
        <i class="pi pi-microchip-ai" aria-hidden="true"></i>
        Só as com bot agendado
      </span>
      <button type="button" aria-label="Mostrar todas as próximas" (click)="tirarSoComBot()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  }

  <!-- Filtro padrão (02/10/2026): as que já começaram sem gravação ficam de fora, com o atalho para ver. -->
  @if (
    aba() !== 'proximas' &&
    aba() !== 'arquivadas' &&
    (ocultasSemGravacao() > 0 || mostrarSemGravacao())
  ) {
    <div class="meetings-page__hidden" role="status">
      <i
        class="pi"
        [class.pi-eye-slash]="!mostrarSemGravacao()"
        [class.pi-eye]="mostrarSemGravacao()"
        aria-hidden="true"></i>
      @if (mostrarSemGravacao()) {
        <span
          >Mostrando também as meetings sem gravação (remarcadas, canceladas, bot não entrou).</span
        >
      } @else {
        <span>
          <strong>{{ ocultasSemGravacao() }}</strong>
          {{
            ocultasSemGravacao() === 1
              ? 'meeting sem gravação oculta'
              : 'meetings sem gravação ocultas'
          }}
          (remarcadas, canceladas, bot não entrou).
        </span>
      }
      <button type="button" (click)="alternarSemGravacao()">
        {{ mostrarSemGravacao() ? 'Ocultar' : 'Mostrar todas' }}
      </button>
    </div>
  }

  @if (erro()) {
    <div class="meetings-page__erro" role="alert">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <span>{{ erro() }}</span>
      <app-button
        [label]="'Tentar de novo'"
        [theme]="'outline-grey'"
        [size]="'small'"
        [type]="'button'"
        (sendButtonClick)="carregar()" />
    </div>
  }

  <section class="meetings-page__list" [class.meetings-page__list--loading]="carregando()">
    @for (grupo of grupos(); track grupo.chave) {
      <h3 class="meetings-page__group">{{ grupo.rotulo }}</h3>
      @for (meeting of grupo.itens; track meeting.id; let firstInGroup = $first) {
        <app-meeting-row
          [meeting]="meeting"
          [showVisibilityLabel]="firstInGroup"
          [aba]="aba()"
          [ocupada]="ocupada() === meeting.id"
          [canArchive]="canArchive()"
          [canDelete]="canDelete()"
          (abrir)="abrir($event)"
          (vincular)="vincular($event)"
          (desvincular)="desvincular($event)"
          (alternarAcesso)="alternarAcesso($event)"
          (alternarBot)="alternarBot($event)"
          (lifecycleAction)="executeLifecycleAction($event)" />
      }
    } @empty {
      @if (!carregando() && !erro()) {
        <div class="meetings-page__vazio">
          <i class="pi pi-video" aria-hidden="true"></i>
          @switch (aba()) {
            @case ('recentes') {
              <strong>Nenhuma meeting recente sua.</strong>
              <span>
                Aparecem aqui as reuniões que você organizou ou de que participou, assim que chega o
                horário. As de outras pessoas com alguém de fora da Legatus, ou compartilhadas,
                ficam em Todas.
              </span>
            }
            @case ('proximas') {
              <strong>
                {{
                  soComBot()
                    ? 'Nenhuma próxima reunião com bot.'
                    : 'Nenhuma meeting agendada para você.'
                }}
              </strong>
              <span>
                Aparecem aqui as reuniões futuras em que você é organizador ou convidado, depois que
                você conecta a conta Microsoft em Preferências › Integrações.
              </span>
            }
            @case ('arquivadas') {
              <strong>Nenhuma reunião arquivada.</strong>
              <span>
                Quem pode arquivar usa Arquivar no menu da linha ou do detalhe. A reunião arquivada
                fica aqui, com a gravação e a transcrição, até alguém restaurar.
              </span>
            }
            @default {
              <strong>Nenhuma meeting encontrada.</strong>
              <span>
                A meeting em que teve alguém de fora da Legatus aparece para todo o time. A call
                interna (e a entrevista) aparece para quem participou e, para o resto do time,
                depois que um participante a compartilha ou libera para o time.
              </span>
            }
          }
        </div>
      }
    }

    @if (total() > 0) {
      <footer class="meetings-page__footer">
        <span class="meetings-page__count"
          >{{ total() }} {{ total() === 1 ? 'meeting' : 'meetings' }}</span
        >
        <p-paginator
          [first]="primeiraLinha()"
          [rows]="linhasPorPagina()"
          [totalRecords]="total()"
          [rowsPerPageOptions]="opcoesDePagina"
          (onPageChange)="handlePagination($event)" />
      </footer>
    }
  </section>

  <app-modal-link-meeting #modalVincular (vinculou)="atualizarLinha($event)" />
  <app-modal-unlink-meeting-deal #modalDesvincular (desvinculou)="atualizarLinha($event)" />
  <app-modal-send-meeting-bot #modalEnviarBot (enviou)="aoEnviarBot()" />
  <app-meeting-visibility-rules-drawer [(visible)]="rulesOpen" />
}
